import { Table } from 'react-bootstrap'
import { TableSubjectRow } from './TableSubjectRow'
import Skeleton from 'react-loading-skeleton'

export function TableSubject({ subjects, faculties, loading }) {
    return (
        <div className='mt-2'>
            <Table>
                <thead>
                    <tr>
                        <th>Materia</th>
                        <th>Código</th>
                        <th className='text-center'>Gestión</th>
                        <th className='text-center'>Periodo</th>
                        <th>Facultad</th>
                        <th className='text-center'>Acción</th>
                    </tr>
                </thead>

                <tbody>
                    {subjects?.length > 0 ? (
                        subjects.map((subject) => (
                            <TableSubjectRow key={subject[0].id} subject={subject} faculties={faculties} />
                        ))
                    ) : (
                        <tr className='text-center'>
                            <td colSpan={6}>{loading ? <Skeleton count={6} height={40} /> : 'No existen materias'}</td>
                        </tr>
                    )}
                </tbody>
            </Table>
        </div>
    )
}
